import { render, staticRenderFns } from "./app-select.vue?vue&type=template&id=9b489bc4&scoped=true&"
import script from "./app-select.vue?vue&type=script&lang=js&"
export * from "./app-select.vue?vue&type=script&lang=js&"
import style0 from "./app-select.vue?vue&type=style&index=0&id=9b489bc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b489bc4",
  null
  
)

export default component.exports